import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

function getSelectedLineId(rootState) {
    if (
        rootState &&
        rootState.lines &&
        rootState.lines.selectedLine &&
        rootState.lines.selectedLine.id
    ) {
        return rootState.lines.selectedLine.id;
    }

    return null;
}

function getPayloadBody(payload, rootState) {
    var selectedLineId = getSelectedLineId(rootState);

    return {
        line_id: payload.line_id ? payload.line_id : selectedLineId,
        code: payload.code,
        description: payload.description,
        commission_percentage: payload.commission_percentage,
        commission_value: payload.commission_value
    };
}

export async function fetchData({ commit, rootState }) {
    commit("setLoading", true);

    try {
        var selectedLineId = getSelectedLineId(rootState);
        var response = await $http.get("/api/sublineas-b");

        var data = response && response.data ? response.data : [];

        if (selectedLineId) {
            data = data.filter(function(item) {
                return String(item.line_id) === String(selectedLineId);
            });
        }

        commit("setData", data);
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    } finally {
        commit("setLoading", false);
    }
}

export async function createData({ commit, dispatch, rootState }, payload) {
    commit("setSaving", true);

    try {
        var body = getPayloadBody(payload, rootState);
        await $http.post("/api/sublineas-b", body);

        Notification.success({
            title: "Éxito",
            message: "Registro creado correctamente",
            type: "success",
            duration: 1500,
            customClass: "notification-box"
        });

        commit("resetForm");
        await dispatch("fetchData");
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    } finally {
        commit("setSaving", false);
    }
}

export async function updateData({ commit, dispatch, rootState }, payload) {
    commit("setSaving", true);

    try {
        var body = getPayloadBody(payload, rootState);
        await $http.put("/api/sublineas-b/" + payload.id, body);

        Notification.success({
            title: "Éxito",
            message: "Registro actualizado correctamente",
            type: "success",
            duration: 1500,
            customClass: "notification-box"
        });

        commit("resetForm");
        await dispatch("fetchData");
    } catch (error) {
        Notification.error({
            title: "Error!",
            message:
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    } finally {
        commit("setSaving", false);
    }
}

export async function deleteData({ commit, dispatch }, id) {
    try {
        await MessageBox.confirm(
            "¿Seguro que deseas eliminar este registro?",
            "Confirmación",
            {
                confirmButtonText: "Sí",
                cancelButtonText: "No",
                type: "warning"
            }
        );

        commit("setDeleting", true);

        await $http.delete("/api/sublineas-b/" + id);

        Notification.success({
            title: "Éxito",
            message: "Registro eliminado correctamente",
            type: "success",
            duration: 1500,
            customClass: "notification-box"
        });

        await dispatch("fetchData");
    } catch (error) {
        if (error !== "cancel") {
            Notification.error({
                title: "Error!",
                message:
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                        ? error.response.data.message
                        : error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        }
    } finally {
        commit("setDeleting", false);
    }
}

export function setForm({ commit }, payload) {
    commit("setForm", payload);
}

export function resetForm({ commit }) {
    commit("resetForm");
}



// WEBPACK FOOTER //
// ./src/modules/sublinesb/actions.js